import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Table, Badge, Button, ProgressBar, Dropdown } from 'react-bootstrap';
import './Releases.css';

const Releases = () => {
  const releases = [
    {
      id: 'REL-003',
      name: 'Mobile App v3.0',
      version: '3.0.0',
      status: 'In QA',
      testCoverage: 87,
      passRate: 92,
      criticalBugs: 2,
      majorBugs: 5,
      minorBugs: 8,
      releaseDate: '2024-03-25',
      goNoGo: 'Pending'
    },
    {
      id: 'REL-002',
      name: 'Payment Gateway Integration',
      version: '2.5.0',
      status: 'In QA',
      testCoverage: 95,
      passRate: 88,
      criticalBugs: 1,
      majorBugs: 3,
      minorBugs: 4,
      releaseDate: '2024-03-20',
      goNoGo: 'Pending'
    },
    {
      id: 'REL-001',
      name: 'Dashboard Redesign',
      version: '2.4.0',
      status: 'Passed',
      testCoverage: 100,
      passRate: 96,
      criticalBugs: 0,
      majorBugs: 1,
      minorBugs: 2,
      releaseDate: '2024-03-10',
      goNoGo: 'Go'
    }
  ];

  const stats = [
    { label: 'Total Releases', value: 12, icon: 'rocket', color: 'primary' },
    { label: 'In QA', value: 3, icon: 'vial', color: 'warning' },
    { label: 'Passed', value: 8, icon: 'check-circle', color: 'success' },
    { label: 'Failed', value: 1, icon: 'times-circle', color: 'danger' }
  ];

  const getStatusBadge = (status) => {
    const variants = { 'In QA': 'warning', 'Passed': 'success', 'Failed': 'danger', 'On Hold': 'secondary' };
    return <Badge bg={variants[status] || 'secondary'}>{status}</Badge>;
  };

  const getGoNoGoBadge = (status) => {
    const variants = { 'Go': 'success', 'No-Go': 'danger', 'Pending': 'warning' };
    const icons = { 'Go': 'check-circle', 'No-Go': 'times-circle', 'Pending': 'clock' };
    return <Badge bg={variants[status] || 'secondary'}><i className={`fas fa-${icons[status]} me-1`}></i>{status}</Badge>;
  };

  return (
    <div className="releases-page">
      <Row className="mb-4 gy-3">
        {stats.map((stat, index) => (
          <Col lg={3} md={6} key={index}>
            <Card className="c-card-1 h-100">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="text-muted small mb-1">{stat.label}</div>
                    <h3 className="mb-0 fw-bold">{stat.value}</h3>
                  </div>
                  <div className={`stat-icon text-${stat.color}`}><i className={`fas fa-${stat.icon}`}></i></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <Card className="c-card-1">
        <Card.Header className="c-card-header-1">
          <span>Release List</span>
        </Card.Header>
        <Card.Body className="c-card-body-1 p-0">
          <Table responsive hover className="mb-0">
            <thead className="bg-light">
              <tr>
                <th className="px-3 py-3 border-0">Release ID</th>
                <th className="px-3 py-3 border-0">Name</th>
                <th className="px-3 py-3 border-0">Version</th>
                <th className="px-3 py-3 border-0">Status</th>
                <th className="px-3 py-3 border-0">Test Coverage</th>
                <th className="px-3 py-3 border-0">Pass Rate</th>
                <th className="px-3 py-3 border-0">Bugs</th>
                <th className="px-3 py-3 border-0">Release Date</th>
                <th className="px-3 py-3 border-0">Go/No-Go</th>
                <th className="px-3 py-3 border-0 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {releases.map((release) => (
                <tr key={release.id}>
                  <td className="px-3 py-3">
                    <Link to={`/qc/releases/${release.id}`} className="text-primary fw-medium">{release.id}</Link>
                  </td>
                  <td className="px-3 py-3"><div className="fw-medium">{release.name}</div></td>
                  <td className="px-3 py-3"><Badge bg="secondary" className="badge-soft">{release.version}</Badge></td>
                  <td className="px-3 py-3">{getStatusBadge(release.status)}</td>
                  <td className="px-3 py-3">
                    <div className="d-flex align-items-center gap-2" style={{minWidth: '120px'}}>
                      <ProgressBar now={release.testCoverage} variant={release.testCoverage >= 90 ? 'success' : release.testCoverage >= 70 ? 'warning' : 'danger'} style={{flex: 1, height: '6px'}} />
                      <span className="text-muted small">{release.testCoverage}%</span>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="d-flex align-items-center gap-2" style={{minWidth: '120px'}}>
                      <ProgressBar now={release.passRate} variant={release.passRate >= 90 ? 'success' : release.passRate >= 70 ? 'warning' : 'danger'} style={{flex: 1, height: '6px'}} />
                      <span className="text-muted small">{release.passRate}%</span>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="d-flex gap-1">
                      {release.criticalBugs > 0 && <Badge bg="danger" title="Critical Bugs">{release.criticalBugs}C</Badge>}
                      {release.majorBugs > 0 && <Badge bg="warning" title="Major Bugs">{release.majorBugs}M</Badge>}
                      {release.minorBugs > 0 && <Badge bg="info" title="Minor Bugs">{release.minorBugs}m</Badge>}
                    </div>
                  </td>
                  <td className="px-3 py-3"><div className="text-muted small">{release.releaseDate}</div></td>
                  <td className="px-3 py-3">{getGoNoGoBadge(release.goNoGo)}</td>
                  <td className="px-3 py-3 text-end">
                    <Dropdown align="end">
                      <Dropdown.Toggle variant="link" className="text-muted p-0"><i className="fas fa-ellipsis-v"></i></Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={`/qc/releases/${release.id}`}><i className="fas fa-eye me-2"></i>View Details</Dropdown.Item>
                        <Dropdown.Item><i className="fas fa-edit me-2"></i>Edit</Dropdown.Item>
                        <Dropdown.Item><i className="fas fa-play me-2"></i>Run Tests</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item className="text-danger"><i className="fas fa-trash me-2"></i>Delete</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Releases;
